import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { ASSESSMENT_TYPES } from 'modules/Assessments/actions'
import { useDispatch } from 'react-redux'

const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
  box-sizing: border-box;
  min-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  background: #ffffff;
`

const ContentCard = styled.div`
  width: 100%;
  padding: 24px 32px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  flex: 1;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

const Title = styled.h1`
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin: 0;
`

const TimerBadge = styled.div`
  padding: 9px 20px;
  background: #e8fff3;
  border-radius: 10px;
  color: #111827;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #5db594;
`

const AssessmentName = styled.div`
  color: #666666;
  font-size: 14px;
  margin-bottom: 40px;
`

const ThankYouText = styled.h2`
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 16px;
`

const Message = styled.p`
  font-size: 14px;
  color: #666666;
  margin: 0;
`

const NextButton = styled.button`
  margin-top: 40px;
  padding: 10px 32px;
  background: #4640de;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  align-self: flex-start;

  &:hover {
    background: #3530ca;
  }
`

const Completion = ({ assessmentData, submittedTime, setAssessment }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`
  }

  const handleNext = () => {
    dispatch({
      type: ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_SUCCESS,
    })
    setAssessment(null)
  }

  return (
    <Container>
      <ContentCard>
        <Header>
          <Title>{assessmentData?.title || 'Behavioral Assessment'}</Title>
          <TimerBadge>Timer : {formatTime(submittedTime)}</TimerBadge>
        </Header>
        <AssessmentName>
          Assessment Name : {assessmentData?.type || 'Behavioral Assessment'}
        </AssessmentName>
        <ThankYouText>Thank you for attending the assessment!</ThankYouText>
        <Message>
          Your result is being processed and will be available shortly. Please
          check the "Completed Assessment" tab to view your score
        </Message>
        <NextButton onClick={handleNext}>Next</NextButton>
      </ContentCard>
    </Container>
  )
}

export default Completion
